import { createAction, props } from '@ngrx/store';

import { CropAid } from '../crop-aid.model';

export const getCropAids = createAction('[Crop aid] Get crop aids');

export const setCropAids = createAction(
  '[Crop aid] Set crop aids',
  props<{ cropAids: CropAid[] }>(),
);
